<template>
  <v-dialog v-model="isOpenDialog" width="1000px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title class="text-uppercase">
          Thêm giáo viên vào nhóm
        </v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card md="12" outlined class="ma-4 elevation-0">
        <TeacherFilter />
      </v-card>
      <v-card md="12" outlined class="mx-4 mb-6 elevation-0">
        <TeacherTable ref="clear" />
      </v-card>
      <hr color="#E0E0E0" />
      <v-card-actions>
        <v-btn class="ma-2" outlined light @click="cancel" width="100px">Hủy</v-btn>
        <v-spacer></v-spacer>
        <div class="pr-4 grey--text">Đã chọn {{ (selectedStudent || []).length }} giáo viên</div>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save" width="100px">Thêm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import TeacherFilter from './TeacherFilter.vue'
import TeacherTable from './TeacherTable.vue'

export default {
  components: {
    TeacherFilter,
    TeacherTable
  },
  data() {
    return {
      isOpenDialog: false,
      type: ''
    }
  },
  computed: {
    ...mapState('salaryGroup', ['group']),
    ...mapState('salaryGroupTeacher', ['selectedStudent'])
  },
  methods: {
    ...mapActions('students', ['requestPageSettings', 'searchStudents']),
    ...mapActions('salaryGroupTeacher', ['addStudent']),
    ...mapMutations('salaryGroupTeacher', ['setSelectedStudent']),

    openDialog(type) {
      this.isOpenDialog = true
      this.type = type
    },
    cancel() {
      this.isOpenDialog = false
    },
    async save() {
      if (this.selectedStudent[0]) {
        try {
          this.$loading.active = true
          let studentExited = await this.addStudent()
          if (studentExited[0]) this.$alert.error({ title: 'Lỗi dữ liệu', description: studentExited.join('<br/>') })
          else {
            this.$alert.success('Thêm Học viên thành công !')
            this.$refs.clear.clearSelected()
            this.cancel()
          }
          this.$loading.active = false
        } catch (error) {
          this.$alert.error(error)
          this.$loading.active = false
        }
      } else {
        this.$alert.error('Vui lòng chọn một Học viên!')
        this.$loading.active = false
      }
    }
  }
}
</script>
